import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/game/img_case_02.webp";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Banner(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="mobileapp_gcc p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
              <div className="banenr_content">
                <h2>Grow Your App with Pioneering Mobile Game Developers</h2>
                <p>
                  Mobile game development projects are big and often take
                  significant time to build. For that much time and money, your
                  most significant investment is the trust you put in a mobile
                  game app development company Dubai. At TekRevol, we have a
                  team of expert game app developers who have built some of the
                  most unique and fascinating games in the market. Our
                  developers and strategists go over game development,
                  developing workable business models that drive revenue and
                  reach the right audience at the most suitable time.
                </p>
                <button onClick={handleShow} className="border_btn">
                  Let’s Get Started!
                </button>
              </div>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto offset-xl-1 offset-lg-1"
            >
              <LazyLoadImage
                src={Img}
                effect="blur"
                alt="game development company"
                className="img-fluid"
              />
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Banner;
